var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'row-area-style': !_vm.nonClass},domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }